module.exports = __webpack_public_path__ + "h5/img/fenc-start.2b9c6204.jpg";